import Image from 'next/image';

export interface RoadmapRowItem {
  year: string | number;
  description: string;
  image?: string;
}

interface RoadmapRowSectionProps {
  items: RoadmapRowItem[];
  add_bottom_border?: boolean;
}

export default function RoadmapRowSection({
  items,
  add_bottom_border = false,
}: RoadmapRowSectionProps) {
  if (!items || items.length === 0) return null;

  return (
    <div
      className={`relative max-w-5xl w-full ${
        add_bottom_border ? 'border-b border-gray-200 pb-10' : ''
      }`}
    >
      <div className="pl-12">
        {items.map((item, idx) => (
          <div
            key={idx}
            className="relative flex flex-col md:flex-row md:items-start"
          >
            {/* Bullet and connector */}
            <div className="absolute left-0 top-0 flex flex-col items-center z-10 h-full">
              <Image
                src={idx === 0 ? '/bullet-2.svg' : '/bullet-1.svg'}
                alt="milestone-bullet"
                width={24}
                height={24}
                className="w-10 h-10"
              />
              {idx < items.length - 1 && (
                <div
                  className="w-1 bg-[#4285F4] flex-1"
                  style={{ minHeight: 80, marginTop: -2 }}
                />
              )}
            </div>

            {/* Year and description */}
            <div className="md:w-1/2 ml-16">
              <h2 className="text-3xl font-bold text-primary-800 mb-2">
                {item.year}
              </h2>
              <div
                className="text-gray-700 text-base mb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6"
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </div>

            {/* Illustration */}
            {item.image && (
              <div className="md:w-1/2 flex justify-center md:justify-end mt-4">
                <Image
                  src={item.image}
                  alt={`Roadmap ${item.year}`}
                  width={300}
                  height={300}
                  className="w-75 h-auto rounded-md bg-white"
                  unoptimized
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
